<template>
    <div class="reset-body">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="reset-card">
            <div class="reset-head">
                <span class="header-text">Reset your password</span>
            </div>
            <div class="reset-input" v-if="msgSend">
                <label for="phone_number" class="input-label"
                    ><span>Phone number*</span></label
                >
                <input
                    placeholder="Enter your phone number"
                    class="input"
                    required
                    type="tel"
                    v-mask="'(###)###-####'"
                    v-model="$v.phone.$model"
                    name="phone_number"
                    id="phone_number"
                />
                <span class="error-form-message" v-if="phoneError"> {{ phoneError }} </span>
                <span class="error-form-message" v-if="phoneValidate">
                    {{ phoneValidate }}
                </span>
                <span class="error-form-message" v-if="$v.phone.$dirty && !$v.phone.required">
                    Required field
                </span>
                <span class="error-form-message" v-if="$v.phone.$dirty && !$v.phone.minLength">
                    Please enter exactly 10 digits
                </span>
            </div>
            <div v-else>
                <span class="mail-send"
                    >Reset Password We have sent your password reset link via a text message.
                    Go Back</span
                >
            </div>

            <div class="w-100" v-if="msgSend">
                <button class="link" @click="resetByPhone">
                    <span class="enter-link">Reset password with your email</span>
                </button>
            </div>
            <button class="call-to-action-btn" @click="phonePassReset">
                <span class="call-to-action-text">Reset password</span>
            </button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

    export default {
        name: 'PasswordResetByPhone',
        validations: {
            phone: {
                required,
                numeric,
                minLength: minLength(10),
                maxLength: maxLength(10)
            }
        },
        data() {
            return {
                phone: '',
                msgSend: true,
                phoneError: false,
                phoneValidate: false,
                load: false
            }
        },
        methods: {
            async phonePassReset() {
                this.load = true
                try {
                    await axios.post('/password/email', {
                        phone_number: this.phone
                    })
                    this.sendEmail()
                    this.load = false
                } catch (error) {
                    this.load = false
                    if (error.response.data.errors.phone_number)
                        this.phoneError = error.response.data.errors.phone_number[0]
                }
            },
            sendEmail() {
                this.msgSend = !this.msgSend
            },
            resetByPhone() {
                window.location.href = '/password/reset-by-email'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    @media screen and (max-width: 600px) {
        .reset-body {
            margin: 0px !important;
        }
        .reset-card {
            margin: 0px !important;
            padding: 0px !important;
            background: inherit !important;
        }
        .header-text {
            font-size: 32px !important;
            font-style: normal;
            font-weight: 500;
            line-height: 120% !important;
            letter-spacing: -0.64px !important;
        }
        .reset-head {
            width: 100%;
        }
        .reset-body {
            margin: 0px !important;
        }
    }
    .reset-body {
        display: flex;
        flex-direction: column;
        margin: 90px 0;
    }
    .reset-card {
        display: flex;
        padding: 48px 80px;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        border-radius: 15px;
        background: #262626;
        width: 100%;
        max-width: 620px;
        margin: 0 auto;
    }
    .header-text {
        color: #f5f5f5;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .input-label {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .reset-input {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-self: stretch;
        position: relative;
    }
    .input {
        display: flex;
        align-self: stretch;
        border-radius: 12px;
        color: #dedede;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        padding: 12px 16px 16px 16px;
        align-items: flex-start;
        gap: 8px;
        text-overflow: ellipsis;
    }
    .input::placeholder {
        overflow: hidden;
        color: #646464;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 125%;
    }

    .call-to-action-btn {
        min-width: 100%;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        border-radius: 100px;
        background: #cdeb09;
        border: none;
    }

    .call-to-action-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .link {
        border: none;
        background: none;
    }
    .enter-link {
        color: #cdeb09;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .mail-send {
        overflow: hidden;
        color: #8b8b8b;
        text-overflow: ellipsis;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .error-form-message {
        color: #ed3c0d;
        font-family: Instrument Sans;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
</style>
